import { Card, EmptyState, PageHeader } from '../ui';

/**
 * What a page looks like before its phase has landed. It names the phase so
 * nobody has to guess whether a screen is missing or simply not built yet.
 */
export function Placeholder({ title, phase }: { title: string; phase: number }): React.JSX.Element {
  return (
    <>
      <PageHeader eyebrow="Not built yet" title={title} />
      <Card>
        <EmptyState title={`This screen arrives in phase ${phase}.`}>
          The route and the shell exist now so that phase only has to supply the page. Nothing is
          broken.
        </EmptyState>
      </Card>
    </>
  );
}
